<template>
<div class="home">
  <div class="order-header">
    <div class="order-header-title">
      <div class="order-header-content">
        <div class="order-header-img"><van-icon name="passed" /></div>
        <div class="order-header-text" v-if="payStatus == 2">
          <span>等待退款</span>
        </div>
        <div class="order-header-text" v-else>
          <span v-if="orStatusType == 0">待支付</span>
          <span v-if="orStatusType == 1">待发货</span>
          <span v-if="orStatusType == 2">待收货</span>
          <span v-if="orStatusType == 3">收货待付款</span>
          <span v-if="orStatusType == 4">已完成</span>
          <span v-if="orStatusType == 5">已取消</span>
        </div>
      </div>
    </div>
  </div>
  <div class="order-info">
    <div class="order-info-box">
      <div class="info-box">
        <div class="order-info-title">订单编号:</div>
        <div class="order-info-text">{{orderNum}}</div>
      </div>
      <div class="info-box">
        <div class="order-info-title">下单时间:</div>
        <div class="order-info-text">{{orderTime}}</div>
      </div>
      <div class="info-box">
        <div class="order-info-title">支付方式:</div>
        <div class="order-info-text">
          <span v-if="orderPaytype == 'wx'">微信</span>
          <span v-if="orderPaytype == 'alipay'">支付宝</span>
          <span v-if="orderPaytype == 'upacp'">银联</span>
          <span v-if="orderPaytype == 'pub_account'">账户余额</span>
        </div>
      </div>
      <div class="info-box">
        <div class="order-info-title">支付时间:</div>
        <div class="order-info-text">{{orPayTime}}</div>
      </div>
      <div class="info-box">
        <div class="order-info-title">配送方式:</div>
        <div class="order-info-text">{{logisticsCmpy}}</div>
      </div>
    </div>
  </div>
  <div class="order-address">
    <div class="order-address-box">
      <div class="address-icon"><van-icon name="location-o" /></div>
      <div class="address-content">
        <div class="address-name">{{orderReceivers}} {{orderReceiverTel}}</div>
        <div class="address-text">地址：{{orderAddr}}</div>
      </div>
    </div>
  </div>
  <div class="order-shop">
    <div class="order-shop-box">
      <div class="order-shop-company">
        <div class="company-img">
          <van-icon name="newspaper-o" />
        </div>
        <div class="company-title">
          <span>{{goodsCompanyName}}</span>
        </div>
      </div>
      <div class="order-shop-list">
        <div class="shop-list-content" v-for="(item,i) in goodsList" :key="i">
          <div class="order-shop-img">
            <img :src="item.orderImg">
          </div>
          <div class="order-shop-content">
            <div class="order-shop-title">{{item.orderPdCname}}</div>
            <div class="order-shop-spec">数量：{{item.orderPdCount}}  规格包装：{{item.orderPdPack}}</div>
            <div class="order-shop-price">¥{{item.orderPdPrice}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="order-message">
    <div class="order-message-box">
      <div class="message-title">买家留言</div>
      <div class="message-text">{{message}}</div>
    </div>
  </div>
  <div class="order-money">
    <div class="order-money-box">
      <div class="money-box">
        <div class="order-money-title">商品金额:</div>
        <div class="order-money-text">¥{{totalBeforeAmount}}</div>
      </div>
      <div class="money-box">
        <div class="order-money-title">运费:</div>
        <div class="order-money-text">+ ¥{{orderFripay}}</div>
      </div>
      <div class="money-box">
        <div class="order-money-title">立减:</div>
        <div class="order-money-text">- ¥{{orderCut}}</div>
      </div>
      <div class="money-box">
        <div class="order-money-title">优惠券:</div>
        <div class="order-money-text">- ¥{{orderCoupon}}</div>
      </div>
      <div class="order-money-total">应付款：<span>¥{{totalAmount}}</span></div>
    </div>
  </div>
</div>
</template>

<script>
import md5 from 'js-md5';
import { orderDetail } from '@/api/resetApi.js'

export default {
  name: 'shopdetails',
  data() {
    return {
      orderId: '',
      customerCode: '',
      date: '',
      datemd5: '',
      orStatusType: '',
      message: '',
      orderNum: '',
      orderTime: '',
      orderPaytype: '',
      orPayTime: '',
      logisticsCmpy: '',
      orderReceivers: '',
      orderReceiverTel: '',
      orderAddr: '',
      totalBeforeAmount: '',
      orderFripay: '',
      orderCut: '',
      orderCoupon: '',
      totalAmount: '',
      goodsCompanyName: '',
      payStatus: '',
      goodsList: [],
    }
  },
  created(){
    this.orderId = this.$route.query.orderId
    this.customerCode = this.$route.query.customerCode
    this.date = this.$route.query.date
    this.datemd5 = md5(this.orderId+this.customerCode+this.date).substring(0,6)
    console.log('datemd5',this.datemd5)
    this.getOrderDetail()
  },
  methods: {
    async getOrderDetail() {
      let data = {
        orderId: this.orderId,
        customerCode: this.customerCode,
        date: this.date,
        token: this.datemd5,
      }
      const res = await orderDetail(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          let reg = /(\d{3})\d{4}(\d{4})/;
          this.orStatusType = res.data.data.orStatusType
          this.payStatus = res.data.data.payStatus
          this.orderNum = res.data.data.orderNum
          this.orderTime = res.data.data.orderTime
          this.orderPaytype = res.data.data.orderPaytype
          this.orPayTime = res.data.data.orPayTime
          this.logisticsCmpy = res.data.data.logisticsCmpy
          this.orderReceivers = res.data.data.orderReceivers
          this.orderReceiverTel = res.data.data.orderReceiverTel.replace(reg, "$1****$2")
          this.orderAddr = res.data.data.orderAddr
          this.message = res.data.data.message
          this.totalBeforeAmount = res.data.data.totalBeforeAmount.toFixed(2)
          this.totalAmount = res.data.data.totalAmount.toFixed(2)

          this.orderFripay = res.data.data.orderFripay?res.data.data.orderFripay.toFixed(2):'0.00'
          this.orderCut = res.data.data.orderCut?res.data.data.orderCut.toFixed(2):'0.00'
          this.orderCoupon = res.data.data.orderCoupon?res.data.data.orderCoupon.toFixed(2):'0.00'
          this.totalAmount = res.data.data.totalAmount?res.data.data.totalAmount.toFixed(2):'0.00'

          this.goodsCompanyName = res.data.data.goodsObject[0].goodsCompanyName
          this.goodsList = res.data.data.goodsObject[0].goodsList
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  max-width: 780px;
  margin: 0 auto;
  background: rgba(249,249,249,1);
}
.order-header {
  width: 100%;
  height: 210px;
  // line-height: 210px;
  font-size: 0;
  text-align: center;
  background: linear-gradient(315deg,rgba(250,101,101,1) 0%,rgba(219,46,46,1) 100%);
  .order-header-title {
    display: inline-block;
    margin-top: 100px;
    height: 25px;
    .order-header-content {
      font-size: 0;
      .order-header-img {
        display: inline-block;
        font-size: 20px;
        color: #fff;
      }
      .order-header-text {
        display: inline-block;
        vertical-align: top;
        margin-left: 5px;
        font-size:18px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
      }
    }
  }
}
.order-info {
  margin-top: -40px;
  padding: 0 15px;
  .order-info-box {
    padding: 10px 10px;
    border-radius: 14px;
    background: #fff;
    .info-box {
      display: flex;
      padding: 10px 0;
      .order-info-title {
        flex: 0 0 60px;
        font-size:14px;
        color:rgba(155,155,155,1);
      }
      .order-info-text {
        flex: 1;
        margin-left: 10px;
        text-align: left;
        font-size:14px;
        color:rgba(24,24,24,1);
      }
    }
  }
}
.order-address {
  margin: 10px 0;
  padding: 0 15px;
  .order-address-box {
    display: flex;
    padding: 20px 10px;
    border-radius: 14px;
    background: #fff;
    .address-icon {
      flex: 0 0 20px;
      font-size: 14px;
      font-weight: bold;
    }
    .address-content {
      flex: 1;
      text-align: left;
      .address-name {
        font-size: 14px;
        color: #181818;
      }
      .address-text {
        padding-top: 20px;
        font-size: 12px;
        color: #9B9B9B;
      }
    }
  }
}
.order-shop {
  margin-bottom: 10px;
  padding: 0 15px;
  .order-shop-box {
    padding: 10px 10px;
    border-radius: 14px;
    background: #fff;
    .order-shop-company {
      display: flex;
      padding: 10px;
      border-bottom: 1px solid #D1D1D1;
      .company-img {
        flex: 0 0 20px;
        font-size: 14px;
      }
      .company-title {
        flex: 1;
        text-align: left;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(74,74,74,1);
      }
    }
    .order-shop-list {
      .shop-list-content {
        display: flex;
        padding: 10px 0;
        border-bottom: 1px solid #D1D1D1;
        &:last-child {
          border-bottom: 0;
        }
        .order-shop-img {
          flex: 0 0 80px;
          align-self: center;
          height: 80px;
          font-size: 0;
          img {
            width: 80px;
            height: 80px;
          }
        }
        .order-shop-content {
          flex: 1;
          margin-left: 10px;
          align-self: center;
          text-align: left;
          .order-shop-title {
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(24,24,24,1);
          }
          .order-shop-spec {
            padding: 10px 0;
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(155,155,155,1);
          }
          .order-shop-price {
            font-size:14px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(24,24,24,1);
          }
        }
      }
    }
  }
}
.order-message {
  padding: 0 15px;
  .order-message-box {
    padding: 20px 10px;
    border-radius: 14px;
    background: #fff;
    text-align: left;
    .message-title {
      padding-left: 10px;
      border-left: 2px solid #EA4747;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-size:12px;
      font-weight:bold;
      color:rgba(24,24,24,1);
    }
    .message-text {
      padding: 10px 10px 0 10px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-size:14px;
      font-weight:400;
      color:rgba(74,74,74,1);
    }
  }
}
.order-money {
  margin: 10px 0 20px;
  padding: 0 15px;
  .order-money-box {
    padding: 10px 20px;
    border-radius: 14px;
    background: #fff;
    .money-box {
      display: flex;
      padding: 10px 0;
      .order-money-title {
        flex: 0 0 60px;
        text-align: left;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(74,74,74,1);
      }
      .order-money-text {
        flex: 1;
        text-align: right;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(24,24,24,1);
      }
    }
    .order-money-total {
      padding: 5px 0 10px 0;
      text-align: right;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(24,24,24,1);
      span {
        color: #EA4747;
      }
    }
  }
}
</style>
